import { getLayoutShapeId } from "../getLayoutShapeId";
import { FLOOR_PLAN_ROOM_ACTIVE_RGB } from "../../rooms/constants";
import { getMergedRoomOutline } from "../../rooms/getMergedRoomOutline";
import { MIN_POLYGON_POINTS } from "../../polygonPointMutators/constants";
import type { FloorPlanLayoutShape } from "components/SmartSurveyor/ReviewPage/FloorPlanPanelNew/SvgOverlay/FloorPlanLayoutLayer";
import type { ApplyMergePreview } from "./types";

const MERGE_PREVIEW_SHAPE_ID = "room-merge-preview";

// The same outline the merge saves, so the preview is exactly the room that will be created.
export const applyMergePreview: ApplyMergePreview = ({
  shapes,
  rooms,
  roomIds,
  wallWidthPt,
}) => {
  if (roomIds === null) return { shapes, mergedShape: null };
  const outline = getMergedRoomOutline({ rooms, roomIds, wallWidthPt });
  if (outline.length < MIN_POLYGON_POINTS) return { shapes, mergedShape: null };

  const mergedShapeIds = new Set(
    roomIds.map((id) => getLayoutShapeId({ kind: "room", id })),
  );
  const mergedShape: FloorPlanLayoutShape = {
    id: MERGE_PREVIEW_SHAPE_ID,
    rings: [outline],
    // The editor's teal, so the room being made reads apart from the plan's room colours.
    rgb: FLOOR_PLAN_ROOM_ACTIVE_RGB,
    label: null,
    tooltip: null,
  };
  return {
    shapes: [
      ...shapes.filter((shape) => !mergedShapeIds.has(shape.id)),
      mergedShape,
    ],
    mergedShape,
  };
};
